export default "__VITE_ASSET__BViVr3bg__"